import React, { FC, isValidElement, cloneElement, createElement } from 'react'

import { useFormContext, get, FieldErrors } from 'react-hook-form'

interface ErrorIntance {
  message: string | null
  type: string
}

interface Props {
  as?: React.ReactElement<{ errors: ErrorIntance[] }> | React.ComponentType<{ errors: ErrorIntance[] }>
  errors?: FieldErrors
  message?: string
  name: string | string[]
  render?: (errors: ErrorIntance[]) => React.ReactNode
}

const ErrorMessage: FC<Props> = ({ as, errors, name, message, render }) => {
  const names = Array.isArray(name) ? name : [name]
  const methods = useFormContext()

  if (!errors && !methods) return null

  const errorInstances = names.reduce((arr, name) => {
    const error = get(errors || methods?.errors, name) as FieldErrors | null
    if (!error) return arr

    const { message: messageFromRegister, type } = error
    let requiredMessage
    if (type === 'required') {
      requiredMessage = 'Required'
    }
    arr.push({ message: messageFromRegister || requiredMessage || message, type })
    return arr
  }, [] as { message: string | null; type: string }[])

  if (!errorInstances.length) {
    return null
  }

  const props = { errors: errorInstances }

  return as ? (
    isValidElement(as) ? (
      cloneElement(as, props)
    ) : (
      createElement(as, props)
    )
  ) : render ? (
    (render(errorInstances) as React.ReactElement)
  ) : (
    <>{errorInstances.map((error) => error.message)}</>
  )
}

export default ErrorMessage
